import React from 'react';
import { Shield, Lock, Heart } from 'lucide-react';

const PrivacyCommitment = () => {
  // Using your brand colors
  const colors = {
    primary: "#122721",
    background: "#6cf168", 
    accent: "#36893B",
    light: "#f8f9fa",
  };

  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        {/* Header with icon */}
        <div className="text-center mb-8 md:mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full mb-4 md:mb-6" 
               style={{ backgroundColor: colors.background }}>
            <Shield className="w-8 h-8 md:w-10 md:h-10" color={colors.primary} strokeWidth={1.5} />
          </div>
          
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 md:mb-4" style={{ color: colors.primary }}>
            Your Privacy. Our Commitment.
          </h2>
          <p className="text-base md:text-lg mx-auto max-w-3xl px-4" style={{ color: colors.primary }}>
            We at Arbaah believe that trust is the foundation of every business relationship.
          </p>
        </div>

        {/* Main commitment message */}
        <div className="max-w-4xl mx-auto text-center mb-8 md:mb-12">
          <h3 className="text-xl md:text-2xl font-semibold mb-3" style={{ color: colors.primary }}>
            We do not own, sell, or exploit your data.
          </h3>
          <p className="text-base md:text-lg text-gray-600">
            We don't rely on advertising, data sales, or third-party monetization.
          </p>
        </div>

        {/* Revenue model highlight - styled like a feature card */}
        <div className="max-w-3xl mx-auto mb-10 md:mb-14">
          <div className="bg-gray-50 rounded-xl p-6 md:p-8 border border-gray-100">
            <div className="flex flex-col sm:flex-row items-center gap-4 md:gap-6">
              <div className="flex-shrink-0">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center" 
                   >
                  <span className="text-2xl md:text-3xl">💚</span>
                </div>
              </div>
              <div className="text-center sm:text-left">
                <p className="text-base md:text-lg font-semibold mb-1" style={{ color: colors.primary }}>
                  The only way we generate revenue is through the software subscription fees you choose to pay.
                </p>
                <p className="text-sm md:text-base text-gray-600">
                  No hidden agenda. No data monetization. Just honest business.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Final statement */}
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-block px-6 py-3 md:px-8 md:py-4 rounded-full" 
               style={{ backgroundColor: colors.light }}>
            <p className="font-semibold text-sm md:text-lg" style={{ color: colors.primary }}>
              Your data stays yours - and our job is to protect it.
            </p>
          </div>
        </div>

        {/* Trust indicators */}
        <div className="flex flex-wrap justify-center gap-6 md:gap-8 mb-8 md:mb-10">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: colors.accent }}></div>
            <span className="text-sm md:text-base text-gray-600">No Third-Party Data Sharing</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: colors.accent }}></div>
            <span className="text-sm md:text-base text-gray-600">GDPR Compliant</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: colors.accent }}></div>
            <span className="text-sm md:text-base text-gray-600">Regular Security Audits</span>
          </div>
        </div>

        {/* CTA - matching the style from your hero section */}
        <div className="text-center">
          <p className="text-sm md:text-base text-gray-600 mb-6">
            Experience the difference of a truly privacy-focused financial platform
          </p>
          <a 
            href="https://app.arbaah.ae/authentication/sign-up" 
            className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 rounded-full font-medium transition-all hover:shadow-lg"
            style={{ backgroundColor: colors.primary, color: "white" }}
          >
            <span className="text-sm md:text-base">Start Your Secure Journey</span>
            <div className="ml-2 bg-white bg-opacity-20 rounded-full w-6 h-6 md:w-8 md:h-8 flex items-center justify-center">
              <svg className="w-3 h-3 md:w-4 md:h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default PrivacyCommitment;